import React from "react";
import { noResult } from "../assets/images/imports";

function NoItemsFound() {
  return (
    <div className="col-span-2 flex flex-col items-center justify-center">
      <img src={noResult} alt="No products found" className="w-64 h-64" />
      <p className="text-xl font-medium text-gray-600 mt-4">No items found</p>
    </div>
  );
}

export default NoItemsFound;
